import {
  container,
  cardTitle,
  whiteColor,
  grayColor,
  blackColor
} from "assets/jss/material-dashboard-pro-react.js";

const loginPageStyle = theme => ({
  container: {
    ...container,
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px"
    }
  },
  cardTitle: {
    ...cardTitle,
    color: blackColor,
    fontWeight: "400" 
  },
  cardSubTitle: {
    ...cardTitle,
    color: blackColor,
    fontWeight: "400"
  },
  textCenter: {
    textAlign: "center"
  },
  justifyContentCenter: {
    justifyContent: "center !important"
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: whiteColor
    },
    marginLeft: "5px",
    marginRight: "5px"
  },
  inputAdornment: {
    marginRight: "18px"
  },
  inputAdornmentIcon: {
    color: grayColor[6]
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  cardHeader: {
    marginBottom: "20px"
  },
  socialLine: {
    padding: "0.9375rem 0"
  },
  floatRight: {
    float: 'right'
  },
  whiteBold: {
    color: 'white',
    fontWeight: 'bold'
  },
  bolder: {
    fontWeight: 'bolder',
    color: 'white',
    textDecoration: 'underline'
  }
});

export default loginPageStyle;
